package one.healthium.insights.ui.shopping_list

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.mapNotNull
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.insights.domain.models.ShoppingListModel
import one.healthium.insights.domain.shopping_list.ShoppingListDataRepository
import one.healthium.insights.ui.shopping_list.models.CategoryUiModel
import one.healthium.insights.ui.shopping_list.models.HeaderUiModel
import one.healthium.insights.ui.shopping_list.models.ShoppingItemUiModel
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class ShoppingListViewModel(
    private val shoppingListDataRepository: ShoppingListDataRepository,
    private val appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(ShoppingListUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()

    init {
        launch {
            appPreferences.isMetricFlow
                .onEach { isMetric ->
                    _state.update { state ->
                        state.copy(isMetric = isMetric)
                    }
                }
                .collect()
        }

        launch {
            _state
                .mapNotNull { it.shoppingList?.id }
                .distinctUntilChanged()
                .flatMapLatest { shoppingListId ->
                    shoppingListDataRepository.getShoppingListData(shoppingListId)
                }
                .catch {
                    Logger.e("error fetch shopping list data", it)
                }
                .collect { shoppingListData ->
                    _state.update { state ->
                        state.copy(shoppingListData = shoppingListData)
                    }
                }
        }
    }

    fun setShoppingList(model: ShoppingListModel) {
        _state.update { state ->
            state.copy(shoppingList = model)
        }
    }

    fun onShoppingItemClicked(uiModel: ShoppingItemUiModel) {
        launch {
            try {
                shoppingListDataRepository.setShoppingListChecked(
                    uiModel.listId,
                    uiModel.id,
                    !uiModel.checked,
                )
            } catch (e: Exception) {
                Logger.e("Failed to update shopping list item", e)
                uiMessages.add(UiMessage.throwable(e))
            }
        }
    }

    fun onCategoryClicked(uiModel: CategoryUiModel) {
        _state.update { state ->
            state.copy(
                selectedCategoryId = if (uiModel == CategoryUiModel.ALL) null else uiModel.id
            )
        }
    }

    fun onUncheckAllClicked(headerUiModel: HeaderUiModel) {
        val shoppingListId = _state.value.shoppingList?.id ?: return
        launch {
            try {

            } catch (e: Exception) {
                Logger.e("Failed to uncheck all in category", e)
                uiMessages.add(UiMessage.throwable(e))
            }
        }
    }
}
